import { AutoCompleteVirtualize } from '@openx/components-core/lib/AutoComplete/AutoCompleteVirtualize';
import { type Dispatch, type SetStateAction, useCallback, useState } from 'react';
import type { FormSegment } from '../../../../../../../../modules/audiences/AudienceForm/types';

type SelectFlatSegmentsProps = {
  label: string;
  placeholder: string;
  options: FormSegment[];
  selectedSegments: FormSegment[];
  setSelectedSegments: Dispatch<SetStateAction<FormSegment[]>>;
  dataTest?: string;
};

export const SelectFlatSegments = ({
  label,
  placeholder,
  options,
  selectedSegments,
  setSelectedSegments,
  dataTest,
}: SelectFlatSegmentsProps) => {
  const [value, setValue] = useState('');

  const filterOptions = useCallback(
    (options: FormSegment[]) => {
      const selectedIds = new Set<string>();

      for (const segment of selectedSegments) {
        selectedIds.add(segment.id);
      }

      const query = value.toLowerCase();

      return options.filter(option => !selectedIds.has(option.id) && option.name.toLowerCase().includes(query));
    },
    [selectedSegments, value]
  );

  return (
    <AutoCompleteVirtualize
      options={options}
      inputValue={value}
      onInputChange={(_e, value, reason) => {
        (reason === 'input' || reason === 'clear') && setValue(value);
      }}
      onChange={(_, newValue) => setSelectedSegments(prev => [...prev, newValue])}
      filterOptions={filterOptions}
      onClose={() => {
        setValue('');
      }}
      getOptionLabel={option => option.name}
      textFieldProps={{
        placeholder: placeholder,
        label: label,
        margin: 'dense',
        sx: { mt: 0 },
      }}
      disableClearable
      disableCloseOnSelect
      isOptionEqualToValue={(option, value) => option.id === value.id}
      fullWidth
      renderOptions={{
        tooltip: true,
      }}
      data-test={dataTest}
    />
  );
};
